import { render, staticRenderFns } from "./statsfittingsalesTab.vue?vue&type=template&id=18bafbe6&"
import script from "./statsfittingsalesTab.vue?vue&type=script&lang=js&"
export * from "./statsfittingsalesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports